import * as React from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import axios from "axios";
import BankDetails from "../../../common/bankdetails/BankDetails";
import { Constants } from "../../constants";
import { withRouter } from "react-router-dom";
/**
 * Bank Details States poperties
 */
interface BankViewState {
  loading: boolean;
  bankName: string;
  fund: string;
  failDate: string;
  fiscalYear: string;
  fiscalQuarter: string;
  publishedDate: string;
  assets: any;
  liabilities: any;
  claimsProven: any;
  claimsOther: any;
  message: any;
}

class BankView extends React.Component<any, BankViewState> {
  // Contructor
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      bankName: "",
      fund: "",
      failDate: "",
      fiscalYear: "",
      fiscalQuarter: "",
      publishedDate: "",
      assets: {},
      liabilities: {},
      claimsProven: {},
      claimsOther: {},
      message: { type: "success", isOpen: false, text: "" }
    };

    this.onAlertCloseAction = this.onAlertCloseAction.bind(this);
    this.onBackActionHandler = this.onBackActionHandler.bind(this);
  }

  /**
   * Force the loading of the bank data once the page is rendered
   */
  componentDidMount() {
    this.setState({ loading: true });
    this.getBankData();
  }

  /**
   * Fetch the bank data
   */
  getBankData = () => {
    if (this.props.bankid) {
      const URI =
        Constants.APP_API + Constants.BANKDETAILS_FETCH_URI + "/" + this.props.bankid;
      axios
        .get(URI)
        .then(resp => this.loadBankData(resp.data))
        .catch(err => {
          console.log(err);
          this.dataLoadErrorAlert();
          return null;
        });
    } else {
      this.noFundErrorAlert();
    }
  };

  /**
   * Notify the user that the bank list data filed to load
   */
  dataLoadErrorAlert() {
    this.setState({
      message: {
        type: "error",
        isOpen: true,
        text: Constants.BANKDETAILS_ERROR_LOAD
      }
    });
  }

  /**
   * Notify the user that the bank list data filed to load
   */
  noFundErrorAlert() {
    this.setState({
      message: {
        type: "error",
        isOpen: true,
        text: Constants.BANKDETAILS_ERROR_NOFUND
      }
    });
  }

  /**
   * Close the error Message alert
   */
  onAlertCloseAction() {
    this.setState({
      message: { type: "success", isOpen: false, text: "" }
    });
  }

  /**
   * Back Button Action Handler
   */
  onBackActionHandler() {
    if (this.props.history && this.props.history.goBack) {
      this.props.history.goBack();
    } else {
      this.props.history.push("../");
    }
  }

  /**
   * Handle the loading of the bank dats
   */
  loadBankData = (data: any) => {
    // testing purposes
    data.fund = "" + this.props.bankid;
    data.name = data.name + " - " + this.props.bankid;

    this.setState({
      loading: false,
      bankName: data.legalName,
      fund: "" + data.fundCode,
      failDate: data.inceptionDate,
      fiscalYear: data.fiscalYear,
      fiscalQuarter: data.fiscalQuarter,
      publishedDate: data.publishedDate,
      assets: {
        cash: data.cashAndInvestmentsAmount,
        due: data.dueFromFdicCorpAndReceivables,
        liquid: data.assetsInLiquidationAmount,
        loss: data.estimatedLossOnAssetsInLiquidationAmount,
        total: data.totalAssetsAmount
      },
      liabilities: {
        admin: data.administrativeLiabilitiesAmount,
        subrogated: data.fdicSubrogatedDepositClaimAmount,
        uninsured: data.uninsuredDepositClaimsAmount,
        other: data.otherClaimaintLiabilitiesAmount,
        unproven: data.unprovenClaimsAmount,
        totalLiab: data.totalLiabilitiesAmount,
        net: data.netWorthAmount,
        total: data.totalLiabilitiesAndNetWorthAmount
      },
      claimsProven: {
        subrogated: [
          data.provenFdicSubrogatedClaimAmount,
          data.provenFdicSubrogatedClaimPercent
        ],
        unisured: [
          data.provenUninsuredDepositorsAmount,
          data.provenUninsuredDepositorsPercent
        ],
        subTotal: [
          data.subTotalProvenDepositClaimsAmount,
          data.subTotalProvenDepositClaimsPercent
        ],
        dividendsPaid: [
          data.provenDividendsPaidToDateAmount,
          data.provenDividendsPaidToDatePercent
        ],
        total: [
          data.totalUnpaidDepositClaimsAmount,
          data.totalUnpaidDepositClaimsPercent
        ]
      },
      claimsOther: {
        general: [data.generalCreditorAmount, data.generalCreditorPercent],
        seniorDebt: [
          data.seniorDebtHoldersAmount,
          data.seniorDebtHoldersPercent
        ],
        subDebt: [
          data.subordinatedDebtHoldersAmount,
          data.subordinatedDebtHoldersPercent
        ],
        subTotal: [
          data.subTotalOtherClaimaintsAmount,
          data.subTotalOtherClaimaintsPercent
        ],
        dividendsPaid: [
          data.otherDividendsPaidToDateAmount,
          data.otherDividendsPaidToDatePercent
        ],
        total: [
          data.totalUnpaidOtherClaimaintsAmount,
          data.totalUnpaidOtherClaimaintsPercent
        ]
      }
    });
  };

  render() {
    let xl1, xl2, xl3, xl4;
    switch (this.state.fund.trim()) {
      case '10539':
        xl1 = Constants.FOOTNOTE1_10539;
        xl2 = Constants.FOOTNOTE2_10539;
        xl3 = Constants.FOOTNOTE3_10539;
        xl4 = null;
        break;
      case '15040':
        xl1 = Constants.FOOTNOTE1_10540;
        xl2 = Constants.FOOTNOTE2_10540;
        xl3 = Constants.FOOTNOTE3_10540;
        xl4 = null;
        break;
      case '10541':
        xl1 = Constants.FOOTNOTE1_10541;
        xl2 = Constants.FOOTNOTE2_10541;
        xl3 = Constants.FOOTNOTE3_10541;
        xl4 = Constants.FOOTNOTE4_10541;
        break;
      case '10542':
        xl1 = Constants.FOOTNOTE1_10542;
        xl2 = Constants.FOOTNOTE2_10542;
        xl3 = Constants.FOOTNOTE3_10542;
        xl4 = Constants.FOOTNOTE4_10542;
        break;
      default:
        xl1 = null;
        xl2 = null;
        xl3 = null;
        xl4 = null;
    }
    // This section is here because the fund number wasn't always picked up
    if (this.state.bankName.toUpperCase().trim() === "SILICON VALLEY BANK") {
      xl1 = Constants.FOOTNOTE1_10539;
      xl2 = Constants.FOOTNOTE2_10539;
      xl3 = Constants.FOOTNOTE3_10539;
      xl4 = null;
    }
    if (this.state.bankName.toUpperCase().trim() === "SIGNATURE BANK") {
      xl1 = Constants.FOOTNOTE1_10540;
      xl2 = Constants.FOOTNOTE2_10540;
      xl3 = Constants.FOOTNOTE3_10540;
    }
    if (this.state.bankName.toUpperCase().trim() === "SIGNATURE BRIDGE BANK") {
      xl1 = Constants.FOOTNOTE1_10541;
      xl2 = Constants.FOOTNOTE2_10541;
      xl3 = Constants.FOOTNOTE3_10541;
      xl4 = Constants.FOOTNOTE4_10541;
    }
    if (this.state.bankName.toUpperCase().trim() === "SILICON VALLEY BRIDGE BANK") {
      xl1 = Constants.FOOTNOTE1_10542;
      xl2 = Constants.FOOTNOTE2_10542;
      xl3 = Constants.FOOTNOTE3_10542;
      xl4 = Constants.FOOTNOTE4_10542;
    }

    return (
      <div className="bankDetails">
        <Row className="detailsButton">
          <Col md="12" lg="12" sm="auto">
            <Button color="primary" onClick={() => this.onBackActionHandler()}>
              Back
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md="12" lg="12" sm="auto">
            <Alert
              color={this.state.message.type}
              isOpen={this.state.message.isOpen}
              toggle={this.onAlertCloseAction}
            >
              {this.state.message.text}
            </Alert>

            <BankDetails
              key={this.state.fund}
              name={this.state.bankName}
              fund={this.state.fund}
              failedDate={this.state.failDate}
              fiscalYear={this.state.fiscalYear}
              fiscalQuarter={this.state.fiscalQuarter}
              assets={this.state.assets}
              liabilities={this.state.liabilities}
              claimsProven={this.state.claimsProven}
              claimsOther={this.state.claimsOther}
              isEditMode={false}
            />
          </Col>
        </Row>
        <Row className="detailsButton">
          <Col md="12" lg="12" sm="auto">
            <Button
              className="detailsButton"
              color="primary"
              onClick={() => this.onBackActionHandler()}
            >
              Back
            </Button>
          </Col>
        </Row>
        <hr />
        <div className="x1">
          <p>{xl1}</p>
        </div>
        <div className="x2">
          <p>{xl2}</p>
        </div>
        <div className="x3">
          <p>{xl3}</p>
        </div>
        <div className="x4">
          <p>{xl4}</p>
        </div>
        <div className="legal">
          <sup>
            <a id="details1" href="#details1">
              (1)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION1}
        </div>
        <div className="legal">
          <sup>
            <a id="details2" href="#details2">
              (2)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION2}
        </div>
        <div className="legal">
          <sup>
            <a id="details3" href="#details3">
              (3)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION3}
        </div>
        <div className="legal">
          <sup>
            <a id="details4" href="#details4">
              (4)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION4}
        </div>
        <div className="subfooter">
          <span>Last Updated: {this.state.publishedDate}</span><span><a href="mailto:cservicefdicdal@fdic.gov">Customer Service</a></span>
        </div>
      </div>
    );
  }
}

export default withRouter(BankView);
